import React from "react";

export default function UploadIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1082 7.67482C14.1138 7.67479 14.1194 7.67478 14.125 7.67478C15.989 7.67478 17.5 9.13251 17.5 10.9308C17.5 12.6067 16.1875 13.9869 14.5 14.1668M14.1082 7.67482C14.1193 7.55565 14.125 7.43497 14.125 7.31301C14.125 5.11518 12.2782 3.3335 10 3.3335C7.84243 3.3335 6.07175 4.93154 5.89032 6.96766M14.1082 7.67482C14.0315 8.49565 13.6964 9.2446 13.1821 9.84541M5.89032 6.96766C3.98799 7.1423 2.5 8.68798 2.5 10.5689C2.5 12.3192 3.78832 13.7791 5.5 14.1143M5.89032 6.96766C6.0087 6.95679 6.12867 6.95123 6.25 6.95123C7.09437 6.95123 7.87355 7.22045 8.50037 7.67478"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99992 10.8335V16.6668M9.99992 10.8335C9.53312 10.8335 8.66094 12.2877 8.33325 12.6564M9.99992 10.8335C10.4667 10.8335 11.3389 12.2877 11.6666 12.6564"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
